export function buildInvoicePdfFilename(invoiceNumber) {
  const safeName = String(invoiceNumber || 'invoice').replace(/[^\w.-]+/g, '_');
  return `${safeName}.pdf`;
}
